export const appUrl = process.env.REACT_APP_BACKEND_URL;
